import { TENDBE_APP_URL } from "./navigation";

export const getPlansTranslated = (t) => [
  {
    id: "freemium",
    kicker: t("landing.plans.freemium.kicker"),
    name: t("landing.plans.freemium.name"),
    price: t("landing.plans.freemium.price"),
    unit: t("landing.plans.freemium.unit"),
    description: t("landing.plans.freemium.description"),
    features: [
      t("landing.plans.freemium.feature_01"),
      t("landing.plans.freemium.feature_02"),
      t("landing.plans.freemium.feature_03"),
    ],
    note: t("landing.plans.freemium.note"),
    cta: {
      label: t("landing.plans.freemium.cta"),
      variant: "outline",
      href: TENDBE_APP_URL,
    },
  },
  {
    id: "premium",
    kicker: t("landing.plans.premium.kicker"),
    name: t("landing.plans.premium.name"),
    price: t("landing.plans.premium.price"),
    unit: t("landing.plans.premium.unit"),
    description: t("landing.plans.premium.description"),
    features: [
      t("landing.plans.premium.feature_01"),
      t("landing.plans.premium.feature_02"),
      t("landing.plans.premium.feature_03"),
      t("landing.plans.premium.feature_04"),
    ],
    cta: {
      label: t("landing.plans.premium.cta"),
      variant: "outline",
      plan: "Premium",
    },
  },
  {
    id: "analyst",
    featured: true,
    kicker: t("landing.plans.analyst.kicker"),
    name: t("landing.plans.analyst.name"),
    price: t("landing.plans.analyst.price"),
    unit: t("landing.plans.analyst.unit"),
    description: t("landing.plans.analyst.description"),
    features: [
      t("landing.plans.analyst.feature_01"),
      t("landing.plans.analyst.feature_02"),
      t("landing.plans.analyst.feature_03"),
      t("landing.plans.analyst.feature_04"),
    ],
    cta: {
      label: t("landing.plans.analyst.cta"),
      variant: "dark",
      plan: "Premium + AI Analyst",
    },
  },
];

export const getSummitPackageTranslated = (t) => ({
  eyebrow: t("landing.plans.summit.eyebrow"),
  name: t("landing.plans.summit.name"),
  description: t("landing.plans.summit.description"),
  price: t("landing.plans.summit.price"),
  unit: t("landing.plans.summit.unit"),
  cta: {
    label: t("landing.plans.summit.cta"),
    variant: "light",
    plan: "Summit Package",
  },
});
